import { slugifyPlace, titleFromSlug } from "../Packages/packages";

export const BOOKING_INCLUSIONS = [
  "Accommodation as per the selected package",
  "Daily breakfast",
  "Sightseeing as mentioned in the itinerary",
  "All applicable taxes",
  "Airport/transport transfers as specified in the package",
];

export const BOOKING_EXCLUSIONS = [
  "Airfare unless specifically included",
  "Personal expenses",
  "Travel insurance",
  "Meals not mentioned in the package",
  "Anything not specifically mentioned under inclusions",
];

export function getBookingPlaceSlug(place) {
  return slugifyPlace(place);
}


export function getBookingDestination(placeSlug) {
  return titleFromSlug(placeSlug);
}


export function getPackageOldPrice() {
  return null;
}


export function getPackagePlaces(route = "") {
  return String(route || "")
    .split("|")
    .map((item) => item.trim())
    .filter(Boolean);
}

export function getBookingItinerary({ package: pkg } = {}) {
  if (!Array.isArray(pkg?.itinerary)) {
    return [];
  }

  return pkg.itinerary.map((item) => ({
    day: item?.day ?? "",
    title: item?.title ?? "",
    points: Array.isArray(item?.points)
      ? item.points.filter(Boolean)
      : item?.description
        ? [item.description]
        : [],
  }));
}
